import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import type { TokenPair, MeResponse } from './api';

interface AuthState {
  accessToken: string | null;
  refreshToken: string | null;
  me: MeResponse | null;
  setTokens: (tokens: TokenPair) => void;
  setMe: (me: MeResponse | null) => void;
  clear: () => void;
}

export const useAuthStore = create<AuthState>()(
  persist(
    (set) => ({
      accessToken: null,
      refreshToken: null,
      me: null,
      setTokens: (tokens) =>
        set({
          accessToken: tokens.accessToken,
          refreshToken: tokens.refreshToken,
        }),
      setMe: (me) => set({ me }),
      clear: () =>
        set({ accessToken: null, refreshToken: null, me: null }),
    }),
    {
      name: 'scorelync-auth',
      // Persist refresh token so reloads survive; access token also
      // persisted but will be quickly rotated on the next call. For
      // Phase 1 this is acceptable; harden later with HttpOnly cookies.
      partialize: (s) => ({
        accessToken: s.accessToken,
        refreshToken: s.refreshToken,
      }),
    },
  ),
);
